module.exports = __webpack_public_path__ + "img/education.dbbc2a2a.png";